import {
  ApiPatientRequest,
  ApiTestPatientRequest,
  TestAgentFormValues,
  TestPatientCopayExclusionOption,
  TestPatientDeductibleOverrideOption,
  TestPatientNotificationOption,
  TestPatientPaymentMethodOption,
} from '../../models';

export class LoadTestPatient {
  static readonly type = '[Test Patients] Load Test Patient';

  constructor(
    public token: string,
    public patientId: number,
    public paymentMethodOption: TestPatientPaymentMethodOption,
    public notificationOption: TestPatientNotificationOption,
    public copayExclusionOption: TestPatientCopayExclusionOption,
    public deductibleOverrideOption: TestPatientDeductibleOverrideOption
  ) {}
}

export class CreateTestAgentOtp {
  static readonly type = '[Test Patients] Sing In Test Agent';
  constructor(public formValues: TestAgentFormValues) {}
}

export class FetchRegistrationTestPatients {
  static readonly type = '[Test Patients] Fetch Test Registration Patients';
}

export class FetchTestPatients {
  static readonly type = '[Test Patients] Fetch Test Patients';
  constructor(public body: ApiTestPatientRequest = {}) {}
}

export class ResetTestPatient {
  static readonly type = '[Test Patients] Rest Test Patient';
  constructor() {}
}

export class UpdateRegistrationTestPatient {
  static readonly type = '[Test Patients] Update Registration Test Patient';
  constructor(public patientId: number, public email: string) {}
}

export class UpdateTestPatient {
  static readonly type = '[Test Patients] Update Test Patient';
  constructor(public patientId: number, public body: ApiPatientRequest) {}
}
